import { Component, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Theme } from 'src/app/theme/theme';
import { ReportService } from '../report.service';

interface ReportDialogData {
  itemType: 'topic' | 'comment';
  itemId: string;
  content: string;
  user: string;
  theme: Theme;
}

@Component({
  selector: 'app-report-dialog',
  templateUrl: './report-dialog.component.html',
  styleUrls: ['./report-dialog.component.scss'],
  standalone: false
})
export class ReportDialogComponent {
  private dialogRef = inject<MatDialogRef<ReportDialogComponent>>(MatDialogRef);
  data = inject<ReportDialogData>(MAT_DIALOG_DATA);
  private reportService = inject(ReportService);

  isLoading = false;
  error?: string;
  reason = '';

  get isReasonInvalid(): boolean {
    const reason = this.reason.trim();
    return reason.length === 0 || reason.length > 255;
  }

  submit(): void {
    const reason = this.reason.trim();
    if (!reason) {
      this.error = 'โปรดระบุเหตุผล';
      return;
    }
    if (reason.length > 255) {
      this.error = 'เหตุผลต้องยาวไม่เกิน 255 ตัวอักษร';
      return;
    }

    this.isLoading = true;
    this.reportService.report(this.data.itemType, this.data.itemId, reason).subscribe({
      next: () => {
        this.isLoading = false;
        this.dialogRef.close();
      },
      error: (err) => {
        this.isLoading = false;
        this.error = err?.error?.message;
      }
    });
  }

  cancel(): void {
    this.dialogRef.close();
  }
}
